<template>
    <div>
        <van-tabs v-model="tabActive" :sticky="true">
            <van-tab :title="tab.title" v-for="(tab, tabIndex) in tabTitle" :key="tabIndex">
                <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh" class="order_list-container">
                    <van-empty v-if="finished && !orderList.length" description="没有产生过订单" />
                    <van-list
                        v-model="listLoading"
                        :finished="finished"
                        loading-text="..."
                        @load="onLoad">
                        <div class="order_item-container"
                            v-for="(item, index) in orderList"
                            :key="'order_item' + index">
                            <van-cell clickable @click="toOrderDetail(item.order_no)">
                                <van-cell class="order_item-card order_id" :title="item.order_no">
                                    <van-tag size="large" :color="getStatusColor(item.status)">{{$store.state.systemEnum.company.user_order && $store.state.systemEnum.company.user_order.status[item.status]}}</van-tag>
                                </van-cell>
                                <commodity-card v-if="orderType" :commodity-info="item"></commodity-card>
                                <template v-if="!orderType">
                                    <van-cell class="order_item-card" title="卡号">
                                        <van-tag size="large" color="#576b95">No.{{item.card_info.card_no}}</van-tag>
                                    </van-cell>
                                    <van-cell class="order_item-card" title="卡类型" :value="item.card_info.type_text"/>
                                </template>
                                <van-cell class="order_item-card" title="订单时间" :value="item.created_at"/>
                                <div class="order_item-checkout">
                                    <div class="order_item-total">总价¥{{item.total_amount}}</div>
                                    <div class="order_item-discounts">优惠¥{{item.discount_amount}}</div>
                                    <div class="order_item-actual_payment">实付¥{{item.paid_amount}}</div>
                                </div>
                            </van-cell>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import api from '../../assets/js/api'
    import CommodityCard from '../../components/beilin/CommodityCard'

    export default {
        name: 'OrderList',
        components: {CommodityCard},
        props: {
            // 订单类型，0为充值，1为消费
            orderType: {
                type: Number,
                default: 0
            }
        },
        data () {
            return {
                refreshLoading: false, //刷新中
                listLoading: false, // 加载中
                finished: false, // 加载全部完成
                orderList: [],
                orderUrlType: ['recharge', 'consume'], // 订单接口类型
                orderLink: ['recharge/detail', 'consume/detail'], // 订单详情页链接
                requestIsLock: false, // 请求锁
                params: {
                    page: 1,
                    pageSize: 10
                },
                tabActive: 0,
                tabTitle: [
                    {
                        title: '全部订单',
                        status: null,
                    }, {
                        title: '待处理',
                        status: 0,
                        color: '#999999',
                    }, {
                        title: '已完成',
                        status: 1,
                        color: '#669944',
                    }, {
                        title: '已退款',
                        status: 3,
                        color: '#aa4246',
                    }
                ]
            }
        },
        watch : {
            tabActive(newValue, oldValue){
                this.onRefresh();
            },
        },
        methods: {
            onRefresh () {
                if (this.requestIsLock) return
                // 刷新则初始化页数
                this.finished = false
                this.refreshLoading = true;
                this.params.page = 1
                this.getOrderList()
            },

            getStatusColor(status) {
                return this.tabTitle.filter(tabItem => tabItem.status == status)[0] ? this.tabTitle.filter(tabItem => tabItem.status == status)[0].color : '#666666'
            },
            // 列表滚动加载
            onLoad () {
                if (this.requestIsLock) return
                this.getOrderList()
            },

            // 获取订单列表数据
            getOrderList () {
                let loading = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                // 关锁
                this.requestIsLock = true
                api.request('/order/list', {
                    status: this.tabTitle[this.tabActive].status,
                    page: this.params.page,
                    page_size: this.params.pageSize,
                    type: this.orderUrlType[this.orderType]
                }).then(res => {
                    // 如果正在刷新则清空列表，并停止刷新
                    if (this.refreshLoading) {
                        this.orderList = []
                        this.refreshLoading = false
                    }
                    // 数据不为空则页数加一，并添加数据至末尾
                    if (!!res.data.data.length) {
                        this.params.page++
                        this.orderList = [...this.orderList, ...res.data.data]
                    }
                    // 判断是否还有数据
                    if (this.orderList.length >= res.data.total) {
                        this.finished = true
                    }
                }).finally(() => {
                    this.listLoading = false
                    this.$toast.clear(loading);
                    // 开锁
                    this.requestIsLock = false
                })
            },

            // 跳转至订单详情页
            toOrderDetail (orderNo) {
                this.$router.push({
                    path: `/${this.$route.params.companyId}/order/${this.orderLink[this.orderType]}`,
                    query: {
                        orderNo: orderNo
                    }
                })
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../style/base.scss';
    *{
        @include themeify{
            .order_list-container {
                padding: 0 10px;

                .order_id {
                    font-weight: bold;
                    font-size: 16px;
                    color: #999;
                }

                .van-pull-refresh {
                    overflow: visible;
                }

                .order_item-container {
                    margin-top: 10px;
                    border-radius: 10px;
                    background: #ffffff;
                    box-shadow: 0 0 5px 0 rgba(0, 0, 0, .05);
                    overflow: hidden;
                }

                .van-cell {
                    padding: 10px 20px;
                }

                .order_item-card{
                    padding:10px 5px;
                    .van-cell__value{
                        overflow: visible;
                        font-size: 16px;
                    }
                    &::after {
                        left: 0;
                        right: 0;
                    }
                }

                .order_item-checkout {
                    display: flex;
                    justify-content: flex-end;
                    font-size: 14px;

                    .order_item-total,
                    .order_item-discounts {
                        margin-right: 5px;
                        color: #969799;
                    }

                    .order_item-actual_payment {
                        padding-left: 0.5rem;
                        font-size: 15px;
                        color: themed('colorText');
                        font-weight: bold;
                    }
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/order/OrderList.vue